import Icon from '../components/Icon.vue'

Icon.register({"caret-up":{"width":1024,"height":1792,"paths":[{"d":"M1024 1216q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-up.js
// module id = 614
// module chunks = 1